import { Vue, Component } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import CohortAccess from '@/routers/views/setup/role-permission/user-list/cohort-access/cohort-access';
import AddUser from '@/routers/views/setup/role-permission/user-list/add-user/add-user';

@Component({
    name: 'role-permission',
    components: {
        'material-icons': GoogleMaterialIcon,
        'user-list': () => import('@/routers/views/setup/role-permission/user-list/user-list'),
        'add-user': AddUser,
        'cohort-access': CohortAccess,
    },
})

export default class RolePermission extends Vue {

    // -----------------------------------------------------------------------
    // Properties

    private activeComponent: any = 'user-list';

    private userData: any = {};

    // ----------------------------------------------------------------------------
    // Actions
    private created() {
        this.$store.dispatch('rosterStore/fetchRolesList');
    }

    private onSwitchComponent(key: string, userData: any) {
        this.userData = userData;
        this.activeComponent = key;
    }

}
